import { render, staticRenderFns } from "./index.vue?vue&type=template&id=33ec43fc"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33ec43fc')) {
      api.createRecord('33ec43fc', component.options)
    } else {
      api.reload('33ec43fc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=33ec43fc", function () {
      api.rerender('33ec43fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/Sidebar/index.vue"
export default component.exports